<div #content [ngClass]="{
  'marker': true,
  'hidden': !markerInstance,
  'fixed-size-marker': !feature?.layer?.style?.icon,
  'topmost-marker': isSelected,
  'info': feature.properties.status === 'info',
  'success': feature.properties.status === 'success',
  'warning':  feature.properties.status === 'warning',
  'danger': feature.properties.status === 'danger' || (feature?.layer?.style?.icon && markerHasAlarms),
  'messages': isFlagged
}">
  <ng-container *ngIf="feature?.layer?.style?.icon; else markerWithLabel">
    <ng-content *ngTemplateOutlet="markerWithIcon"></ng-content>
  </ng-container>
</div>

<ng-template #markerWithIcon>
  <span *ngIf="isFlagged" class="badge badge-pill badge-danger flag">
    <i class="fas fa-flag fa-lg"></i>
  </span>
  <div
    [ngClass]="{ 'labeled-marker': true, 'selected-marker': isSelected }"
    [class.active-alarm]="markerHasAlarms && !isSelected">
    <span
      *ngIf="isLabelVisible$ | async"
      class="marker-label"
      [ngClass]="feature.properties.markerTitleClass">
      {{ feature.properties[feature.layer.style.label.text] }}
    </span>
    <svg
      (click)="onClick($event);"
      (dblclick)="onDBLClick($event)"
      [ngClass]="feature.properties.markerIconClass + ' click-area'"
      [style.fill]="markerFillColor"
      [style.height]="markerHasAlarms ? '44px' : '25px'"
      [style.width]="markerHasAlarms ? '44px' : '25px'"
      [attr.id]="attrId"
      [inlineSVG]="feature.layer.style.icon.url">
    </svg>
  </div>
</ng-template>

<ng-template #markerWithLabel>
  <div *ngIf="feature"
    [ngClass]="{
      'train-marker': feature.layer.metadata.group === 'Trains',
      'equipment-marker': feature.layer.metadata.group === 'Equipment',
      'selected-marker': isSelected,
      'marker-offset': isSelected
    }"
    [attr.id]="attrId">
    <span *ngIf="feature.properties.markerIconClass?.indexOf('messages') !== -1"
          class="fa-layers fa-fw fa-4x badge message-badge"
          style="background:MistyRose">
       <span class="fa-layers-counter fa-5x">
         {{feature.properties.messageCount}}
       </span>
    </span>
    <span *ngIf="isFlagged" class="badge badge-pill badge-danger flag">
      <i class="fas fa-flag fa-lg"></i>
    </span>
    <div
      [ngClass]="feature.properties.markerIconClass + ' click-area'"
      [style.transform]="'rotate(' + feature.properties.direction + 'deg)'"
      (click)="onClick($event)"
      (dblclick)="onDBLClick($event)">
      <div
        [ngClass]="feature.properties.markerTitleClass + ' click-area'" *ngIf="feature.properties.subTitle"
        [style.transform]="'rotate(' + markerRotation + 'deg)'"
        (click)="onClick($event)"
        (dblclick)="onDBLClick($event)">
        <span>{{feature.properties.title}}</span>
        <hr class="train-marker-divider">
        <span *ngIf="feature.properties.subTitle">
          {{feature.properties.subTitle}}
        </span>
      </div>
      <div
        *ngIf="!feature.properties.subTitle"
        (click)="onClick($event)"
        (dblclick)="onDBLClick($event)"
        [ngClass]="feature.properties.markerTitleClass + ' click-area'"
        [style.transform]="'rotate(-' + feature.properties.direction + 'deg)'">
        <span>{{feature.properties.title | qmTruncate: 5}}</span>
        <span *ngIf="feature.properties.title">
          {{feature.properties.title}}
        </span>
      </div>
    </div>
  </div>
</ng-template>
